import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'
import { inject, observer } from 'mobx-react'

import { restoreAuthPageState } from '~/utilities/authPageState'

/**
 * After magic-link or social auth, rehydrate parking search criteria and refetch results
 * so users land back where they were without re-entering plate/ticket info.
 */
const AuthReturnStateHandler = observer(({ isLoggedIn, store }) => {
  const router = useRouter()
  const restoredForSession = useRef(false)

  useEffect(() => {
    if (!router.isReady || !isLoggedIn || !store || restoredForSession.current) return

    restoredForSession.current = true
    restoreAuthPageState(store).catch((err) => {
      console.error('Error restoring page state after auth', err)
    })
  }, [isLoggedIn, router.isReady, store])

  useEffect(() => {
    if (!isLoggedIn) {
      restoredForSession.current = false
    }
  }, [isLoggedIn])

  return null
})

export default inject((all) => ({
  store: all.store,
  isLoggedIn: all.store.auth.isLoggedIn,
}))(AuthReturnStateHandler)
